import styled from '@emotion/styled';

export const PageContent = styled.div`
  min-height: 100vh;
`;
